"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AskICISWrapper = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
const AskICISWrapper = exports.AskICISWrapper = _styledComponents.default.div.withConfig({
  displayName: "AskICISstyle__AskICISWrapper",
  componentId: "sc-bs6v28-0"
})(["display:flex;align-items:center;gap:4px;height:52px;margin:0 4px;> div{margin-top:2px;height:16px;}"]);